import { Typography, Box } from '@mui/material'
import { TooltipText } from 'components/TooltipText/TooltipText'
import RepeatIcon from '@mui/icons-material/Repeat'
import { ReactComponent as ImmediateIcon } from 'assets/images/icon-asap-slot.svg'
import { useEffect, useRef, useState } from 'react'
import { Event as BigCalendarEvent } from 'react-big-calendar'
import { useTranslation } from 'react-i18next'
import theme from 'lib/theme'
import { isAfter } from 'date-fns'
import { SlotIcon } from './BigCalendar.styled'

interface CalendarEvent extends BigCalendarEvent {
  immediate?: boolean
}

const Text = ({ title }: { title: string }) => {
  const { t } = useTranslation()
  return (
    <>
      <Typography variant='body2'>
        {(title as string).split('\n')[0]}
      </Typography>
      <Typography>
        {t('serviceArea.orderQuota')}: {(title as string).split('\n')[1]}
      </Typography>
    </>
  )
}

const getWhiteSpace = (width: number, height: number) => {
  if (width < 35 && width >= 20 && height > 8) {
    return 'wrap'
  }
  if (width < 20 || width >= 35) {
    return 'nowrap'
  }
  return 'pre'
}

export const Event = ({ event }: { event: CalendarEvent }) => {
  const someRef = useRef<HTMLDivElement>(null)

  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  const trackingDimensions = () => {
    if (someRef !== null && someRef.current !== null) {
      setWidth(someRef.current.offsetWidth)
      setHeight(someRef.current.offsetHeight)
    }
  }

  useEffect(() => {
    trackingDimensions()
    window.addEventListener('resize', trackingDimensions)
  }, [])

  useEffect(
    () => () => {
      window.removeEventListener('resize', trackingDimensions)
    },
    []
  )

  const inThePast = isAfter(
    new Date().setHours(0, 0, 0, 0),
    event.start as Date
  )
  return (
    <Box height='100%' ref={someRef}>
      <TooltipText text={<Text title={event.title as string} />}>
        <Box
          sx={{
            whiteSpace: getWhiteSpace(width, height),
            writingMode: width > 20 ? 'horizontal-tb' : 'vertical-lr',
            textOrientation: width > 20 ? 'sideways' : 'upright',
          }}>
          <Box
            sx={{
              maxHeight: theme.spacing(6),
              overflowY: width > 20 ? 'hidden' : 'visible',
            }}>
            <Box display='flex'>
              {event.resource === 'Recurrent' && (
                <SlotIcon inThePast={inThePast} component={RepeatIcon} />
              )}
              {event.immediate && (
                <SlotIcon inThePast={inThePast} component={ImmediateIcon} />
              )}
              <Typography variant='body2'>
                {(event.title as string).split('\n')[0]}
              </Typography>
            </Box>
          </Box>
          <Typography>{(event.title as string).split('\n')[1]}</Typography>
        </Box>
      </TooltipText>
    </Box>
  )
}
